import { useTranslation } from 'react-i18next';
import { ArrowUpRight, SlidersHorizontal } from 'lucide-react';
import { hostVetrina } from '@/app/marca';
import s from './vetrina.module.css';

/**
 * L'insegna della vetrina: la striscia che dice «quello dentro lo schermo e'
 * il prodotto, questa riga no».
 *
 * 🚨 Non e' piu' il banco di prova. La barra con le quattro aree stava qui, e
 * il banco — comporre un impianto e poi entrarci — era diviso in due posti: il
 * configuratore dentro l'app e le aree in una barra sopra di essa. Ora il
 * banco e' UNO SOLO e sta sul sito del prodotto, dove il prodotto viene
 * raccontato: `www.emacomfort.com` ([ADR-090] — stava su
 * `www.puglieseweb.com/products/ema-comfort`). Li' si compone l'impianto e si
 * sceglie da quale area entrarci; qui resta l'app, aperta su quell'impianto.
 *
 * Quindi questa striscia fa due cose, e nessuna terza:
 *
 * - **dice che e' una dimostrazione** — chip, tavolozza propria, una riga di
 *   testo. Senza, l'app dentro la cornice sarebbe solo un'app;
 * - **riporta al banco**. E' l'unica strada per cambiare impianto o area, e
 *   deve esserci: chi apre il link del pannello non ha altro modo di arrivare
 *   all'area tecnica, e un vicolo cieco su un indirizzo pubblico costa il
 *   valutatore.
 *
 * 🚨 Solo su un host vetrina. Su un host installatore l'app e' l'impianto di
 * qualcuno: nessuna insegna, nessun rimando al sito. La guardia resta qui e
 * non solo in `Vetrina`, cosi' il componente e' inerte anche se qualcuno lo
 * montasse altrove.
 */
export function Insegna() {
  const { t } = useTranslation();

  if (typeof window === 'undefined' || !hostVetrina(window.location.hostname)) return null;

  return (
    <div className={s.barra}>
      <span className={s.etichetta}>{t('demo.insegna.etichetta')}</span>
      <span className={s.titolo}>{t('demo.insegna.titolo')}</span>
      <span className={s.nota}>{t('demo.insegna.nota')}</span>
      <span className={s.spazio} />
      {/* Stessa scheda, di proposito: si torna al banco da cui si e' arrivati,
          non si apre una seconda finestra sullo stesso sito. */}
      <a className={s.ritorno} href={t('demo.insegna.bancoUrl')}>
        <SlidersHorizontal size={16} aria-hidden />
        {t('demo.insegna.banco')}
        <ArrowUpRight size={14} aria-hidden />
      </a>
    </div>
  );
}
